import { DNA } from '../visual-language'

export function cardStyles() {
  return {
    textAlign: 'start',
    display: 'block',
    padding: DNA.tokens.alias.dimension.size.medium,
    marginBlockStart: DNA.tokens.alias.dimension.size.xsmall,
    borderWidth: DNA.tokens.alias.dimension.borderSize.default,
    borderStyle: 'solid',
    borderRadius: DNA.tokens.alias.dimension.borderRadius.default,
    backgroundColor: 'rgba(202,202,202, 0.2)',
    borderColor: 'rgba(179, 179, 179, 0.5)',
  }
}
